import AboutYouComponent from "./components/labeledinput/AboutYouComponent";
import AboutYouInputComponent from "./components/input/AboutYouInputComponent";
import CustomerFeedbackComponent from "./components/labeledinput/CustomerFeedbackComponent";
import CustomerFeedbackInputComponent from "./components/input/CustomerFeedbackInputComponent";
import HasBrokerComponent from "./components/labeledinput/HasBrokerComponent";
import HasBrokerInputComponent from "./components/input/HasBrokerInputComponent";
import AddressComponent from "./components/labeledinput/AddressComponent";
import AddressInputComponent from "./components/input/AddressInputComponent";
import PhoneNumberComponent from "./components/labeledinput/PhoneNumberComponent";
import PhoneInputComponent from "./components/input/PhoneInputComponent";
import SecurityQuestionsComponent from "./components/labeledinput/SecurityQuestionsComponent";
import SecurityQuestionsInputComponent from "./components/input/SecurityQuestionsInputComponent";
import TradeClearComponent from "./components/labeledinput/TradeClearComponent";
import TradeClearInputComponent from "./components/input/TradeClearInputComponent";
import EnhancedSecurityComponent from "./components/EnhancedSecurityComponent";
import UserDataService from "./common/UserDataService";
import ConvertExternalToCglComponent from "./components/ConvertExternalToCglComponent";
import FederationUserDataComponent from "./components/FederationUserDataComponent";
import PhoneVerificationComponent from "./components/PhoneVerificationComponent";
import LoginContactInfoComponent from "./components/labeledinput/LoginContactInfoComponent";
import LoginContactInfoInputComponent from "./components/input/LoginContactInfoInputComponent";
import PolicyAgreementComponent from "./components/labeledinput/PolicyAgreementComponent"
import PolicyAgreementInputComponent from "./components/input/PolicyAgreementInputComponent"
import DuoSetupComponent from "./components/DuoSetupComponent";
import DuoAuthSetupComponent from "./components/DuoAuthSetupComponent";
import UniversalDuoInfoComponent from "./components/UniversalDuoInfoComponent";
import WorkInfoInputComponent from "./components/input/WorkInfoInputComponent";
import Duo from "./components/Duo-Web-v2.min";
import UpdatePasswordInputComponent from "./components/input/UpdatePasswordInputComponent";
import EmailUpdateVerificationComponent from "./components/EmailUpdateVerificationComponent";

import { PROP_NAME_STREET } from "./components/input/StreetInputComponent";
import { PROP_NAME_COUNTRY } from "./components/input/CountryInputComponent";
import { PROP_NAME_POSTAL_CODE } from "./components/input/PostalCodeInputComponent";
import { PROP_NAME_CITY } from "./components/input/CityInputComponent";
import { PROP_NAME_STATE } from "./components/input/StateInputComponent";

import {
    PROP_NAME_PHONE_COUNTRY_CODE,
    PROP_NAME_PHONE_NUMBER,
    PROP_NAME_PHONE_EXTENSION,
    PROP_NAME_PHONE_2FA_CHANNEL,
    PROP_NAME_PHONE_IS_MOBILE
} from "./components/input/PhoneInputComponent";
import {
    PROP_NAME_JOB_ROLE,
    PROP_NAME_COMPANY_NAME,
    PROP_NAME_COMPANY_TYPE
} from "./components/input/AboutYouInputComponent";
import {PROP_NAME_CAN_CONTACT_FEEDBACK} from "./components/input/CustomerFeedbackInputComponent";
import {PROP_NAME_MARKETING_COMMUNICATIONS_APPROVAL} from "./components/input/PolicyAgreementInputComponent";
import {PROP_NAME_SEC_Q1, PROP_NAME_SEC_Q2, PROP_NAME_SEC_Q3} from "./components/input/SecurityQuestionsInputComponent";
import {
    PROP_NAME_TRADES_FUTURES,
    PROP_NAME_TRADES_OPTIONS_ON_FUTURES,
    PROP_NAME_TRADES_DOES_NOT_TRADE,
    PROP_NAME_TRADES_FX_SPOT_AND_FORWARDS,
    PROP_NAME_TRADES_CASH_TREASURIES_AND_REPO,
    PROP_NAME_TRADES_OTC_CLEARED_SWAPS
} from "./components/input/TradeClearInputComponent";
import VerifyEmailComponent from "./components/verifyemail/VerifyEmailComponent";
import { PROP_NAME_HAS_BROKER } from "./components/input/HasBrokerInputComponent";

export const userData = {
    AboutYouComponent,
    HasBrokerComponent,
    HasBrokerInputComponent,
    AboutYouInputComponent,
    CustomerFeedbackComponent,
    CustomerFeedbackInputComponent,
    AddressComponent,
    AddressInputComponent,
    PhoneNumberComponent,
    PhoneInputComponent,
    SecurityQuestionsComponent,
    SecurityQuestionsInputComponent,
    TradeClearComponent,
    TradeClearInputComponent,
    EnhancedSecurityComponent,
    UserDataService,
    ConvertExternalToCglComponent,
    FederationUserDataComponent,
    PhoneVerificationComponent,
    VerifyEmailComponent,
    LoginContactInfoComponent,
    LoginContactInfoInputComponent,
    PolicyAgreementComponent,
    PolicyAgreementInputComponent,
    DuoSetupComponent,
    DuoAuthSetupComponent,
    UniversalDuoInfoComponent,
    WorkInfoInputComponent,
    Duo,
    UpdatePasswordInputComponent,
    EmailUpdateVerificationComponent,

    formFields: {
        // Address
        PROP_NAME_STREET,
        PROP_NAME_COUNTRY,
        PROP_NAME_POSTAL_CODE,
        PROP_NAME_CITY,
        PROP_NAME_STATE,

        // phone
        PROP_NAME_PHONE_COUNTRY_CODE,
        PROP_NAME_PHONE_NUMBER,
        PROP_NAME_PHONE_EXTENSION,
        PROP_NAME_PHONE_2FA_CHANNEL,
        PROP_NAME_PHONE_IS_MOBILE,

        // About You
        PROP_NAME_JOB_ROLE,
        PROP_NAME_COMPANY_TYPE,
        PROP_NAME_COMPANY_NAME,

        // Contact feedback
        PROP_NAME_CAN_CONTACT_FEEDBACK,

        // Policy agreement
        PROP_NAME_MARKETING_COMMUNICATIONS_APPROVAL,

        // Security Questions
        PROP_NAME_SEC_Q1,
        PROP_NAME_SEC_Q2,
        PROP_NAME_SEC_Q3,

        // Trade/clear
        PROP_NAME_TRADES_FUTURES,
        PROP_NAME_TRADES_OPTIONS_ON_FUTURES,
        PROP_NAME_TRADES_OTC_CLEARED_SWAPS,
        PROP_NAME_TRADES_CASH_TREASURIES_AND_REPO,
        PROP_NAME_TRADES_FX_SPOT_AND_FORWARDS,
        PROP_NAME_TRADES_DOES_NOT_TRADE,

        // Has Broker
        PROP_NAME_HAS_BROKER
    }
};
